import { render, staticRenderFns } from "./update-button.vue?vue&type=template&id=7067860b&scoped=true&"
import script from "./update-button.vue?vue&type=script&lang=ts&"
export * from "./update-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7067860b",
  null
  
)

export default component.exports